import axios from "axios";
import React, { useEffect, useState } from "react";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Redirect, useHistory } from "react-router-dom";
import { Table } from "../../../components/CustomPaginations";
import {
	dateCol,
	statusColor,
	tableStyle,
} from "../../../components/TableStyle";
import Header from "../../../components/Header";
import FilterationBar from "./FilterationBar";
import { ReviewedLeaveApplication_API } from "./ReviewedLeaveApplication_API";
import { AlertPopups } from "../../../components/AlertPopups";
import moment from "moment";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";
import ActionFormatter from "./ActionFormatter";
import CustomeSearchBar from "../../../components/CustomeSearchBar";
import ButtonLoader from "../../../components/ButtonLoader";
import { ExcelBtnClassName, ExcelBtnTitle } from "../../ticketModule/variables/ListingVariables";

function ReviewedLeaveApplication() {
	let token,
		empDesignation,
		empRole = null;
	let history = useHistory();
	const defaultSorted = [
		{
			dataField: "startDate",
			order: "desc",
		},
	];
	const [spReviewedLeaveData, setSpReviewedLeaveData] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState();
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [leaveTypes, setLeaveTypes] = useState(null);
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [selectedSupEmp, setSelectedSupEmp] = useState(null);
	const [selectedLeaveType, setSelectedLeaveType] = useState(null);
	const [endDatePickerDisabled, setEndDatePickerDisabled] = useState(true);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const formatter = (row, ActionFormatter) => <ActionFormatter row={row} />;
	const getStatusText = (status) => {
		if (status === "Pending") return "Pending";
		else if (status === "InProgress") return "Pending";
		else if (status === "Invalid") return "Invalid";
		else if (status === "Approved") return "Approved";
		else if (status === "Rejected") return "Rejected";
		else return "Pending";
	};

	//Table columns
	const getColumns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "leaveType",
			text: "Leave Type",
			sort: true,
		},
		{
			dataField: "startDate",
			text: "Start Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "endDate",
			text: "End Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "leaveDuration",
			text: "Leave Duration",
			sort: true,
		},
		{
			dataField: "supervisorStatus",
			text: "Supervisor Status",
			sort: true,
			formatter: getStatusText,
			style: statusColor,
		},
		{
			dataField: "adminManagerStatus",
			text: "Admin Status",
			sort: true,
			formatter: getStatusText,
			style: statusColor,
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => formatter(row, ActionFormatter),
		},
	];
	useEffect(() => {
		let pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};

		if (empRole.includes("3")) {
			//admin
			pageSize = GlobalPaginationSize.AdminPaginationSize;
			setNumberOfItemsPerPage(pageSize);

			axios
				.get(`${ReviewedLeaveApplication_API.GetAdminEmployeesList}`, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						let removeAllStatus = supEmpList.filter(
							(item) => item.label != "All"
						);
						let sorted = removeAllStatus.sort((a, b) =>
							a.label.localeCompare(b.label)
						);
						sorted.unshift({ value: 0, label: "All" });
						setSupervisorsEmpList(sorted);
						setSelectedSupEmp({ value: 0, label: "All" });
					}
				});
		} else {
			//get Supervisor Employee List
			axios
				.get(
					`${ReviewedLeaveApplication_API.GetSupervisorsEmployeesList}`,
					{
						headers: tokenHeader,
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						let removeAllStatus = supEmpList.filter(
							(item) => item.label != "All"
						);
						let sorted = removeAllStatus.sort((a, b) =>
							a.label.localeCompare(b.label)
						);
						sorted.unshift({ value: 0, label: "All" });
						setSupervisorsEmpList(sorted);
						if (sessionStorage.getItem("ReviewedLeaveApplication"))
							if (
								JSON.parse(
									sessionStorage.getItem(
										"ReviewedLeaveApplication"
									)
								)[0]
							) {
								setSelectedSupEmp(
									JSON.parse(
										sessionStorage.getItem(
											"ReviewedLeaveApplication"
										)
									)[0]
								);
							} else
								setSelectedSupEmp({ value: 0, label: "All" });
						else setSelectedSupEmp({ value: 0, label: "All" });
					}
				});
		}

		//start date
		if (sessionStorage.getItem("ReviewedLeaveApplication"))
			if (
				JSON.parse(
					sessionStorage.getItem("ReviewedLeaveApplication")
				)[2]
			) {
				setStartDate(
					new Date(
						JSON.parse(
							sessionStorage.getItem("ReviewedLeaveApplication")
						)[2]
					)
				);
			} else setStartDate(moment(new Date()).subtract(60, "days")._d);
		else setStartDate(moment(new Date()).subtract(60, "days")._d);

		//end date
		if (sessionStorage.getItem("ReviewedLeaveApplication"))
			if (
				JSON.parse(
					sessionStorage.getItem("ReviewedLeaveApplication")
				)[3]
			) {
				setEndDate(
					new Date(
						JSON.parse(
							sessionStorage.getItem("ReviewedLeaveApplication")
						)[3]
					)
				);
			} else setEndDate(moment(new Date())._d);
		else setEndDate(moment(new Date())._d);

		//get leave Types
		axios
			.get(`${ReviewedLeaveApplication_API.GetLeaveTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const types = data.types;
					types.unshift({ value: 0, label: "All" });
					setLeaveTypes(
						types.sort((a, b) => a.label.localeCompare(b.label))
					);
					if (sessionStorage.getItem("ReviewedLeaveApplication"))
						if (
							JSON.parse(
								sessionStorage.getItem(
									"ReviewedLeaveApplication"
								)
							)[1]
						) {
							setSelectedLeaveType(
								JSON.parse(
									sessionStorage.getItem(
										"ReviewedLeaveApplication"
									)
								)[1]
							);
						} else setSelectedLeaveType(types[0]);
					else setSelectedLeaveType(types[0]);
				}
			});

		//get table data
		let employeeId = 0;
		let type = 0;
		let startDate = moment(new Date())
			.subtract(60, "days")
			.format(APIDateFormat);
		let endDate = moment(new Date()).format(APIDateFormat);
		if (sessionStorage.getItem("ReviewedLeaveApplication")) {
			if (
				JSON.parse(
					sessionStorage.getItem("ReviewedLeaveApplication")
				)[0]
			)
				employeeId = JSON.parse(
					sessionStorage.getItem("ReviewedLeaveApplication")
				)[0].value;

			if (
				JSON.parse(
					sessionStorage.getItem("ReviewedLeaveApplication")
				)[1]
			)
				type = JSON.parse(
					sessionStorage.getItem("ReviewedLeaveApplicati=-098n")
				)[1].value;
		}
		axios
			.get(
				`${ReviewedLeaveApplication_API.GetReviewedLeaves_API}StartDate=${startDate}&EndDate=${endDate}&EmployeeId=${employeeId}&Type=${type}&PageSize=${pageSize}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewedLeaveData(res.data.leaveApplications);
				}
			});
		setApiHeaderToken(tokenHeader);
	}, []);

	const onDateFilteration = (StartDate, EndDate) => {
		//api call on filteration
		setIsLoading(true);
		const StartDateFormated = moment(StartDate).format(APIDateFormat);
		const endDateFormated = moment(EndDate).format(APIDateFormat);
		axios
			.get(
				`${ReviewedLeaveApplication_API.GetReviewedLeaves_API}StartDate=${StartDateFormated}&EndDate=${endDateFormated}&EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&PageNumber=${pageNum}&Type=${selectedLeaveType.value}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewedLeaveData(res.data.leaveApplications);
				} else {
					AlertPopups.ErrorAlert.fire({
						text: "error.response.data.message",
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};
	const updateTableData = (empId, leaveType) => {
		setIsLoading(true);
		let apiURL = "";
		if (startDate) {
			const StartDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			apiURL = `${ReviewedLeaveApplication_API.GetReviewedLeaves_API}Type=${leaveType}&EmployeeId=${empId}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiURL = `${ReviewedLeaveApplication_API.GetReviewedLeaves_API}Type=${leaveType}&EmployeeId=${empId}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		}
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				setIsLoading(false);
				setPageNum(1);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setSpReviewedLeaveData(res.data.leaveApplications);
			});
	};

	const receiveData = (PageSize) => {
		//api call for table poage size change
		setIsLoading(true);
		let apiUrl = "";
		if (startDate) {
			const StartDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			apiUrl = `${
				ReviewedLeaveApplication_API.GetReviewedLeaves_API
			}&EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}&PageSize=${PageSize}&PageNumber=${1}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiUrl = `${
				ReviewedLeaveApplication_API.GetReviewedLeaves_API
			}&EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}&PageSize=${PageSize}&PageNumber=${1}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}`;
		}

		axios
			.get(apiUrl, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewedLeaveData(res.data.leaveApplications);
				}
			});
	};
	const exportToExcel = (e) => {
		;
	
		e.preventDefault();
		setIsLoading(true);
		let apiUrl = "";
		if (startDate) {
			const StartDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			apiUrl = `${
				ReviewedLeaveApplication_API.ExportToExcel
			}?EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiUrl = `${
				ReviewedLeaveApplication_API.ExportToExcel
			}?EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}`;
		}

		axios
			.get(apiUrl, {
				headers: apiHeaderToken,
				responseType: "blob",
			})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute(
					"download",
					"ReviewedLeaveApplication.xlsx"
				);
				document.body.appendChild(link);
				link.click();
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	};


	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//api call for handle table change
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (startDate) {
			const StartDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			if (type === "sort") {
				apiURL = `${ReviewedLeaveApplication_API.GetReviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Type=${selectedLeaveType.value}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
				setSortBy({ dataField: sortField, order: sortOrder });
				getData = true;
			} else if (type === "pagination") {
				apiURL = `${ReviewedLeaveApplication_API.GetReviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Type=${selectedLeaveType.value}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
				getData = true;
			}
		} else {
			if (type === "sort") {
				apiURL = `${ReviewedLeaveApplication_API.GetReviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Type=${selectedLeaveType.value}`;
				setSortBy({ dataField: sortField, order: sortOrder });
				getData = true;
			} else if (type === "pagination") {
				apiURL = `${ReviewedLeaveApplication_API.GetReviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Type=${selectedLeaveType.value}`;
				getData = true;
			}
		}

		if (getData) {
			axios
				.get(apiURL, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setSpReviewedLeaveData(res.data.leaveApplications);
					}
				});
		}
	};

	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("ReviewedLeaveApplication"))
			obj = JSON.parse(
				sessionStorage.getItem("ReviewedLeaveApplication")
			);
		if (property === "emp") obj[0] = value;
		else if (property === "type") obj[1] = value;
		else if (property === "startDate") obj[2] = value;
		else if (property === "endDate") obj[3] = value;
		sessionStorage.setItem("ReviewedLeaveApplication", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `/SpReviewedLeave/${row.id}`,
			});
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				empDesignation = userDetails.designation;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Reviewed Leave Applications"
								headerBorder="true"
							/>

							<FilterationBar
								supervisorsEmpList={supervisorsEmpList}
							
								selectedSupEmp={selectedSupEmp}
								onSupEmpChange={(value) => {
									setSelectedSupEmp(value);
									storeFiltersStates(value, "emp");
									updateTableData(
										value.value,
										selectedLeaveType.value
									);
								}}
								leaveTypes={leaveTypes}
								selectedLeaveType={selectedLeaveType}
								onLeaveTypeChange={(value) => {
									setSelectedLeaveType(value);
									storeFiltersStates(value, "type");
									updateTableData(
										selectedSupEmp.value,
										value.value
									);
								}}
								startDate={startDate}
								endDate={endDate}
								endDatePickerDisabled={endDatePickerDisabled}
								onStartDateChange={(startDate) => {
									setStartDate(startDate);
									storeFiltersStates(startDate, "startDate");
									//if user select start date again after selecting end date(when end date is enabled)
									if (endDate) {
										onDateFilteration(startDate, endDate);
									} else {
										setEndDatePickerDisabled(false);
									}
								}}
								onEndDateChange={(endDate) => {
									setEndDate(endDate);
									storeFiltersStates(endDate, "endDate");
									onDateFilteration(startDate, endDate);
								}}
							/>

<div className="d-flex justify-content-end">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={isLoading}
									disabled={
										!spReviewedLeaveData.length || isLoading
									}
								/>
							</div>

							{/*Table with Pagination*/}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"id"}
											columns={getColumns}
											items={spReviewedLeaveData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											loading={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											adminPagination={empRole.includes(
												"3"
											)}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection
				);
			}}
		</UserConsumer>
	);
}

export default ReviewedLeaveApplication;
